import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { loadStrategy } from "../components/strategy/strategyAction";
import Nav from "../components/nav/Nav";
import AxisSection from "../components/axis/AxisSection";
import StrategyModal from "../components/modal/StrategyModal";
import {Outlet, useNavigate} from "react-router-dom";
import DisplaySwotButton from "../components/buttons/DisplaySwotButton";
import SwotModal from "../components/modal/SwotModal";
import StrategyStacks from "../components/strategy/StrategyStacks";
import { DisplayForHead } from "../permissions/DisplayAccordingToRole";
import AddButtonFullText from "../components/buttons/AddButtonFullText";
import AxisModal from "../components/modal/AxisModal";
import { CLEAR_AXIS, CLEAR_ONE_AXIS } from "../components/axis/actionTypes";
import EditButton from "../components/buttons/EditButton";
import NextCodirModal from "../components/modal/NextCodirModal";
import { getDateInFrench } from "../utils/dateUtils";
import logoCoach from "../images/coachEnjoyNoBg.png"
import {
  IS_HEAD,
  ROLE_AMBASSADOR,
  ROLE_CODIR,
  ROLE_ENJOY,
} from "../permissions/roleTypes";

const StrategyPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.currentUser);
  const [navIsOpen, setNavIsOpen] = useState(false);
  const [isOpenSwotModal, setIsOpenSwotModal] = useState(false);
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [fieldSelected, setFieldSelected] = useState("");
  const { name, nextCodir, id, useAssistant, useLearning } = useSelector((state) => state.strategy);
  const [selectedAxisId, setSelectedAxisId] = useState(0);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openUpdateNextCodir, setOpenUpdateNextCodir] = useState(false);

  useEffect(() => {
    dispatch(loadStrategy());
    return () => {
      dispatch({ type: CLEAR_AXIS });
      dispatch({ type: CLEAR_ONE_AXIS });
    };
  }, [dispatch]);

  const editStrategy = (name) => {
    setFieldSelected(name);
    setIsOpenEditModal(true);
  };
  const nextCodirFR = nextCodir ? getDateInFrench(nextCodir) : "";

  const handleCoachClick = () => {
    navigate('/coach-enjoy-strategie')
  }

  return (
    <Page>
      <Outlet />
      <Nav setNavIsOpen={setNavIsOpen} navIsOpen={navIsOpen} />
      <Wrapper>
        {openUpdateNextCodir && (
          <NextCodirModal id={id} setOpen={setOpenUpdateNextCodir} />
        )}
        <TitleSection>
          <TitleAndButtons>
            <h1> {name ? name : "Stratégie"} </h1>
            <ButtonsWrapper>
              <DisplaySwotButton
                  name={"SWOT stratégie"}
                  setOpenModal={setIsOpenSwotModal}
              />
              <DisplayForHead
                  component={
                    <AddButtonFullText
                        id={selectedAxisId}
                        setId={setSelectedAxisId}
                        setUpdate={setOpenCreateModal}
                        title={"Ajouter un axe"}
                    />
                  }
              />
              <Codir>
                <p>
                  Prochain CODIR : {nextCodir ? nextCodirFR : "non renseigné"}{" "}
                </p>
                {(currentUser.roles.includes(ROLE_CODIR) ||
                    currentUser.roles.includes(ROLE_AMBASSADOR) ||
                    currentUser.roles.includes(ROLE_ENJOY)) && (
                    <EditButton
                        setUpdate={setOpenUpdateNextCodir}
                        data={openUpdateNextCodir}
                    />
                )}
              </Codir>
            </ButtonsWrapper>
          </TitleAndButtons>
          {
            IS_HEAD(currentUser.roles) && useAssistant &&
            <Coach>
              <img onClick={handleCoachClick} src={logoCoach} alt="coach-enjoy"/>
              <h2>Comment puis-je vous aider ?</h2>
            </Coach>
          }
        </TitleSection>
        <Container>
          <FirstSection>
            <StrategyStacks isInteractive={true} editStrategy={editStrategy}/>
          </FirstSection>
          <AxisStakeContainer>
            <AxisSection/>
          </AxisStakeContainer>
        </Container>
        {isOpenEditModal && (
            <StrategyModal value={fieldSelected} setIsOpen={setIsOpenEditModal}/>
        )}
        {isOpenSwotModal && (
            <SwotModal
                name={"Stratégie"}
                entity={"strategy"}
                setIsOpenModal={setIsOpenSwotModal}
            />
        )}
        {openCreateModal && (
            <AxisModal
                setOpenModal={setOpenCreateModal}
                selectedId={selectedAxisId}
            />
        )}
      </Wrapper>
    </Page>
  );
};

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media screen and (min-width: 1000px){
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }
`;

const TitleAndButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;
const Page = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  gap: 1rem;
  max-width: 1600px;
  @media (min-width: 1200px) {
    display: grid;
    grid-template-columns: 300px 1fr;
  }
`;
const FirstSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  @media (min-width: 700px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  @media (min-width: 1200px) {
    flex-direction: column;
    height: fit-content;
  }
`;

const AxisStakeContainer = styled.div`
  padding: 2rem;
  display: flex;
  justify-content: center;
  border-radius: 15px;
  background-color: var(--color-pale-blue);
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  
  @media screen and (min-width: 1000px){
    flex-direction: row;
  }
`;
const Codir = styled.div`
  display: flex;
  align-items: center;
  p {
    font-size: 1.1rem;
  }
`;

const Coach = styled.div`
  display: flex;
  max-width: 25%;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  img{
    max-width: 100px;
  }
  img:hover{
    cursor: pointer;
  }
  h2{
    display: none;
  }
  @media screen and (min-width: 1000px){
    align-self: flex-end;
    align-items: flex-end;

    h2{
      display: inline-block;
    }
  }
`
export default StrategyPage;
